<template>
	<div class="head-table">
		<div class="columns columns-custom ">
      <div class="column" v-for="item in itemsCount" :key="item.value" >
        <span class="column-header">{{item.text}}</span>
      </div>
    </div>  
	</div>
</template>

<script>
export default {
  name: "headTable",
  props: {
    itemsCount: {
      type: Array
    }
  }
};
</script>

<style lang="scss" scoped>
.head-table {
  max-width: 1200px;
  padding: 0 30px;

  // box-shadow: 0px 0px 0.5px 0px rgba(0,0,0,0.75);
}
.column {
  // font-weight: bold;
  &:nth-child(1) {
    text-align: left;
    span {
      padding-left: 20%;
    }
  }
}
.column:nth-last-child(1) {
  span {
    opacity: 0;
  }
}
.column:nth-last-child(2),
.column:nth-last-child(3) {
  span {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Componentes/headTable.vue